import axios from "axios";
import {Message} from "element-ui";
import store from "@/store";

export let fileRequest = axios.create({
    baseURL: process.env.VUE_APP_FILE,
    withCredentials: true,
});
fileRequest.interceptors.request.use(
    (config) => {

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

fileRequest.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (response.status == 200) {
            return Promise.resolve(res);

        } else {
            Message({
                message: res.message || res.msg || "Error",
                type: "error",
                duration: 5 * 1000,
            });
            return Promise.reject(new Error(res.message || res.msg || "Error"));
        }
    },
    (error) => {
        Message({
            message: error.msg,
            type: "error",
            duration: 5 * 1000,
        });
        return Promise.reject(error);
    }
);


export let request = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    withCredentials: true,
});

request.interceptors.request.use(
    (config) => {
        
        config.headers.userId = store.state.user.userId;
        config.headers.userToken = store.state.user.token;
        config.headers.nickName = encodeURIComponent(store.state.user.nickName);
        config.headers.srcSymbol = store.state.user.srcSymbol
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
request.interceptors.response.use(
    (response) => {
        const res = response.data
        if (res.code != 0 && res.code != 200) {
            if(res.code == 401){
                Message({
                    message: res.message||res.msg || "Error",
                    type: "error",
                    duration: 5 * 1000,
                });
                let data = {
                    source: "similarity",
                    info: {
                        actionType: 1
                    },
                };
                window.parent.postMessage(JSON.stringify(data), "*");
            }
            Message({
                message: res.message || res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(res.message)
        } else {
            // return Promise.reject(new Error(res.msg || 'Error'))
            return Promise.resolve(res)
        }

    },
    (error) => {
        Message({
            message: error.msg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error);
    }
);


export let downRequest = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    responseType: "blob",
    withCredentials: true,
});
downRequest.interceptors.request.use(
    (config) => {
        config.headers.userId = store.state.user.userId;
        config.headers.userToken = store.state.user.token;
        config.headers.nickName = encodeURIComponent(store.state.user.nickName);
        config.headers.srcSymbol = store.state.user.srcSymbol
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

downRequest.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (response.status == 200) {
            return Promise.resolve(response);
        }  else {
            Message({
                message: res.message||res.msg || "Error",
                type: "error",
                duration: 5 * 1000,
            });
            return Promise.reject(new Error( res.message||res.msg || "Error"));
        }
    },
    (error) => {
        Message({
            message: error.msg,
            type: "error",
            duration: 5 * 1000,
        });
        return Promise.reject(error);
    }
);


export let trackservice = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    withCredentials: true,
});
trackservice.interceptors.request.use(
    (config) => {
        config.headers.userId = store.state.user.userId;
        config.headers.userToken = store.state.user.token;
        config.headers.nickName = encodeURIComponent(store.state.user.nickName);
        config.headers.srcSymbol = store.state.user.srcSymbol
        config.headers.Authorization = store.state.user.token;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
trackservice.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.code != 200 && res.code != 0) {
            return Promise.reject("Error");
        } else {
            return Promise.resolve(res);
        }
    },
    (error) => {
        return Promise.reject("Error");
    }
);
